import { createAuth0 } from '@auth0/auth0-vue'

// Import Auth0 config
const domain = import.meta.env.VITE_APP_AUTH0_DOMAIN
const clientId = import.meta.env.VITE_APP_AUTH0_CLIENT_ID
const audience = import.meta.env.VITE_APP_AUTH0_AUDIENCE

export const auth0 = createAuth0({
  domain: domain,
  clientId: clientId,
  // audience: audience,
  authorizationParams: {
    // redirect_uri: baseUrl,
    // eslint-disable-next-line compat/compat
    redirect_uri: window.location.origin,
    audience: audience
  }
})
